import { IntegrationChannelType, IntegrationType } from 'generated/graphql';

interface GetIsCohortUserIdentifierIntegrationParams {
  channelType: IntegrationChannelType;
  integrationType: IntegrationType;
}

export const getIsCohortUserIdentifierIntegration = ({
  channelType,
  integrationType,
}: GetIsCohortUserIdentifierIntegrationParams) => {
  return (
    integrationType === IntegrationType.Cohorts &&
    (channelType === IntegrationChannelType.Amplitude ||
      channelType === IntegrationChannelType.MixPanel)
  );
};
